import { Box } from '@chakra-ui/react'
import DocumentToReactRender from '~/components/shared-components/DocumentToReactRender/DocumentToReactRender'
import { type IWysiwygContent } from '~/types/generated/contentful'

import Container from '../../grid/Container/Container'

export default function WysiwygContent({
  content,
}: {
  content: IWysiwygContent
}) {
  return (
    <Box className="wysiwyg-content" py="64px" overflowX="hidden">
      <Container>
        <DocumentToReactRender
          componentData={content.fields.content}
          fieldId="content"
          entryId={content.sys.id}
        />
      </Container>
    </Box>
  )
}
